<div data-cy="tool-card" class="flex flex-col">
  <div class="mb-1 flex w-full flex-col items-center pt-5">
    @if (authService.getCurrentEmployee().isAdmin) {
      <button data-cy="tool-card-remove-button" (click)="createRemoveModal()" class="bg-lightGrayish z-10 -mb-4 flex">
        @if (tool.status === EToolStatus.CLOSED) {
          <img data-cy="trash-icon" src="../../../assets/img/icons/delete.png" class="h-7" alt="delete icon" />
        } @else {
          <img src="../../../assets/img/icons/solve.png" class="h-8" alt="solve" />
        }
      </button>
    }
    <div
      class="border-sunflowerGold bg-paleOrange relative flex w-full flex-col border-2 p-3 max-lg:pt-5 max-lg:text-xs lg:p-5 lg:px-8"
      data-cy="tool-item"
    >
      <div class="flex flex-col" data-cy="tool-card-content" [ngClass]="{ 'mb-2 gap-6': showMore }">
        <!-- AI Tool Image -->
        @if (getImageUrl()) {
          <div class="mt-4 flex justify-center">
            <img
              src="{{ toolImage }}"
              class="h-32 w-32 rounded-md object-cover shadow-md"
              alt="{{ tool.toolName }} image"
            />
          </div>
        }
        <div class="mt-4 flex justify-center">
          <span class="text-lg" data-cy="tool-title">{{ tool.toolName }}</span>
        </div>

        <div class="flex flex-col gap-1">
          <span class="text-sm font-semibold">Description</span>
          <span class="text-xs" data-cy="tool-description">{{ tool.description }}</span>
        </div>
        @if (showMore) {
          <div class="flex flex-col gap-6">
            <div class="flex gap-6 max-md:flex-col">
              <div class="flex w-60 flex-col gap-1">
                <span class="text-sm font-semibold">Advantages</span>

                <ol class="list-inside pl-4" data-cy="tool-advantages">
                  @for (advantage of tool.advantages; track advantage) {
                    <li class="text-xs" data-cy="tool-advantage">• {{ advantage }}</li>
                  }
                </ol>
              </div>
              <div class="flex w-60 flex-col gap-1">
                <span class="text-sm font-semibold">Disadvantages</span>
                <ol class="list-inside pl-4" data-cy="tool-disadvantages">
                  @for (disadvantage of tool.disadvantages; track disadvantage) {
                    <li class="text-xs" data-cy="tool-disadvantage">• {{ disadvantage }}</li>
                  }
                </ol>
              </div>
            </div>
            <div class="flex gap-6">
              <div class="flex w-60 flex-col gap-1">
                <span class="text-sm font-semibold">Company</span>
                <span class="text-xs" data-cy="tool-company">
                  {{ tool.company }}
                </span>
              </div>
              <div class="flex w-60 flex-col gap-1">
                <span class="text-sm font-semibold">Website</span>
                <a
                  href="{{ tool.website }}"
                  target="_blank"
                  class="max-w-[14rem] cursor-pointer overflow-hidden text-xs text-ellipsis whitespace-nowrap underline"
                  data-cy="tool-website"
                >
                  {{ tool.website }}
                </a>
              </div>

              <div class="flex flex-col gap-1 sm:hidden">
                <span class="text-sm font-semibold">Author</span>
                <span class="text-xs">
                  {{ tool.createdBy.firstname + ' ' + tool.createdBy.lastname }}
                </span>
              </div>
            </div>
            <div class="flex flex-1 flex-col gap-1">
              <span class="text-sm font-semibold">Conclusion</span>
              <span class="text-xs">
                {{ tool.conclusion }}
              </span>
            </div>
          </div>
        }
        <div class="flex w-full items-center justify-center">
          <button class="text-sunflowerGold mt-4 flex items-center gap-2 text-sm" (click)="showMore = !showMore">
            {{ showMore ? 'show less' : 'show more ...' }}
          </button>
        </div>
      </div>
      <div class="mt-5 flex w-full items-center justify-center gap-1 max-sm:relative max-sm:flex-col-reverse">
        <div class="absolute top-6 left-3 gap-2 text-sm max-sm:hidden lg:left-8">
          <div>
            <span class="font-semibold">Author: </span>
            <span class="">{{ tool.createdBy.firstname + ' ' + tool.createdBy.lastname }}</span>
          </div>
          <div>
            <span class="font-semibold">Created: </span>
            <span class="">{{ tool.createdAt | date: 'yyyy-MM-dd' }}</span>
          </div>
        </div>

        <div class="left-5 flex items-center gap-4 max-md:w-full md:absolute lg:left-8">
          <!-- Category -->
          <div class="bg-sunflowerGold flex cursor-pointer gap-2 rounded-sm border px-2 py-1 text-xs text-white">
            <fa-icon [icon]="badgeIcon" class="text-white"></fa-icon>
            <span>{{ tool.category }}</span>
          </div>
          <!-- Comments -->
          <button (click)="toggleComments()" class="flex items-center gap-2" data-cy="toggle-comments-button">
            <fa-icon class="lg:scale-125" [icon]="commentIcon"></fa-icon>
            <span class="text-xs"> {{ tool.comments.length }}</span>
          </button>
        </div>

        <div class="flex w-full items-center justify-between">
          <!-- Left section - empty for alignment -->
          <div class="w-1/3"></div>

          <!-- Middle section - Voting Up/Down -->
          <div class="flex w-1/3 items-center justify-center gap-2">
            @if (tool.status != EToolStatus.CLOSED) {
              <button (click)="voteTool(tool, 'down')" data-cy="downvote-button">
                <img class="h-7 rotate-180" src="../../../assets/img/icons/arrow-up.png" alt="Arrow down" />
              </button>
            }
            <p class="font-bold lg:text-2xl" data-cy="vote-count">{{ tool.voteCount }}</p>
            @if (tool.status != EToolStatus.CLOSED) {
              <button (click)="voteTool(tool, 'up')" data-cy="upvote-button">
                <img class="h-7" src="../../../assets/img/icons/arrow-up.png" alt="Arrow up" />
              </button>
            }
          </div>

          <!-- Right section - Links -->
          <div class="flex w-1/3 justify-end gap-4">
            @if (tool.fileUrl) {
              <!-- File URL (optional) -->
              <div>
                <a [href]="tool.fileUrl" target="_blank" class="text-black underline" [title]="'View attached file'">
                  <fa-icon [icon]="faLink" class="h-3 w-3 align-middle"></fa-icon>
                  <span class="pl-1 text-xs">File</span>
                </a>
              </div>
            }

            <!-- WordPress Post ID Badge -->
            <div>
              @if (tool.wpPostId) {
                <a
                  [href]="'https://42-projects.com/?post_type=ki-tool&p=' + tool.wpPostId"
                  target="_blank"
                  class="color-black underline"
                  [title]="'Published on WordPress with post ID ' + tool.wpPostId + ' media ID ' + tool.wpMediaId"
                >
                  <fa-icon [icon]="faWordpress" class="h-3 w-3 align-middle"></fa-icon>
                  @if (tool.hasUnpublishedContent || tool.hasUnpublishedImage) {
                    <span class="pl-1 text-xs">Unpublished changes</span>
                  } @else {
                    <span class="pl-1 text-xs">Published</span>
                  }
                </a>
              } @else {
                <span class="text-xs">Not published</span>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="absolute right-4 flex gap-2">
        @if (authService.getCurrentEmployee().isAdmin || tool.createdBy._id === authService.getCurrentEmployee()._id) {
          <button (click)="onEditClick()" data-cy="edit-tool-button" title="Edit AI tool review">
            <img src="../../../assets/img/icons/edit.png" class="h-5" alt="edit icon" />
          </button>
          @if (tool.hasUnpublishedContent || tool.hasUnpublishedImage) {
            <button (click)="onPublishClick()" data-cy="publish-tool-button" title="Publish to WordPress">
              <img src="../../../assets/img/icons/wordpress.png" class="h-5 w-5" alt="publish icon" />
            </button>
          }
        }
      </div>
    </div>
    @if (showComments) {
      <div
        #commentContainer
        class="border-sunflowerGold bg-paleOrange max-h-80 w-full overflow-y-auto border-x-2 border-b-2"
        data-cy="tool-comments-list"
      >
        @for (comment of tool.comments; track comment; let last = $last) {
          <div
            class="bg-paleOrange relative mx-4 flex flex-col justify-center gap-2 py-2 text-xs"
            data-cy="tool-single-comment"
            [ngClass]="{ 'border-b border-white': !last }"
          >
            <div class="text-sunflowerGold mr-2 flex gap-2">
              <span> {{ comment.commentedAt | date: 'dd.MM' }}</span>
              <span>-</span>
              <span>{{ comment.commentedBy.firstname }} {{ comment.commentedBy.lastname }}</span>
            </div>
            <span class="mr-8 flex-1 break-words">{{ comment.comment }}</span>
            @if (comment.commentedBy._id === authService.getCurrentEmployee()._id) {
              <img
                data-cy="comment-delete-button"
                (click)="deleteComment(comment._id)"
                src="assets/img/icons/delete.png"
                class="absolute right-2 h-4"
                alt="delete icon"
              />
            }
          </div>
        }

        <div class="bg-paleOrange relative flex items-center">
          <input
            class="no-focus h-10 w-full resize-none p-2 text-xs outline-none placeholder:text-xs"
            data-cy="comment-input"
            placeholder="Write a comment..."
            (keyup)="onKeyUp($event)"
            [(ngModel)]="newComment"
          />

          <button
            class="flex h-10 w-12 items-center justify-center bg-white p-1"
            (click)="onCreateComment()"
            data-cy="tool-create-comment-button"
          >
            <img class="h-4" src="../../../assets/img/icons/send.png" alt="send" />
          </button>
        </div>
      </div>
    }
  </div>

  @if (confirmDialog) {
    <app-confirm-dialog
      (closeDialog)="confirmDialog = false"
      (saveChanges)="onDeleteModalConfirmation()"
      [data]="modalData"
    ></app-confirm-dialog>
  }

  @if (confirmPublishDialog) {
    <app-confirm-dialog
      (closeDialog)="confirmPublishDialog = false"
      (saveChanges)="onPublishConfirmation()"
      [data]="modalData"
    ></app-confirm-dialog>
  }
</div>
